export default {
  login: '/login',
  oauth2LoginSuccess: '/oauth2-login-success',
  oauth2LogoutSuccess: '/',
  changePassword: '/change-password',
  forgotPassword: '/forgot-password',
  preview: '/app/survey',
  surveys: {
    parent: '/surveys',
    children: {
      new: 'new',
      preview: ':id/preview',
      publish: '/surveys/:id/publish'
    }
  },
  questions: {
    parent: '/surveys/:surveyId/questions',
    children: {
      edit: ':id/questions',
      list: 'questions'
    }
  },
  preloadVariable: {
    parent: '/surveys/:surveyId/preload-variable',
    children: {
      edit: ':id/preload-variable',
      list: 'questions'
    }
  }
};
